"use client";

import dynamic from "next/dynamic";

export const ReactQueryDevToolProvider = dynamic(
  () =>
    import("@/app/[lng]/_components/react-query-devtools-provider").then(
      (mod) => mod.ReactQueryDevToolProviderInternal,
    ),
  {
    ssr: false,
  },
);
